export const lengthUnitSelector = (state) => state.get("units").length;

export const forceUnitSelector = (state) => state.get("units").force;

export default {
  lengthUnitSelector,
  forceUnitSelector,
};
